<main>
    <div class="col-12">
        <div class="row">
            <div class="col-sm-6 col-md-9">
                <div _ngcontent-cvh-c14="" class="component-title mb-3">
                    EXTRATO DE RECARGAS
                </div>
                <p>Visualize seu extrato de recargas</p>
            </div>
        </div>
        <div class="separador-2"></div>
        <div class="row">
            <div class="col-md-12 text-right" *ngIf="true">
                <ul class="options-cadastro">
                    <li>
                        <div (click)="showFilter(filtro)" class="list-select ml-2
                            my-1">
                            <button _ngcontent-khv-c20="" class="list-select" type="button">
                                Aplicar filtro
                            </button>
                        </div>
                    </li>
                    <li class="ml-2">
                        <div class="list-filter-show-item">Mostrar:
                            <select [(ngModel)]="showItem" (ngModelChange)="changeLimit($event)">
                                <option [ngValue]="10" value="10" selected>10</option>
                                <option [ngValue]="25" value="25">25</option>
                                <option [ngValue]="50" value="50">50</option>
                                <option [ngValue]=100 value="100">100</option>
                            </select>
                        </div>
                    </li>
                </ul>
            </div>

        </div>

        <div class="row mt-5">
            <div class="col-12">

                <div class="table-responsive rm-overflow-x">
                    <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0"
                        *ngIf="true">
                        <thead>
                            <tr>
                                <th class="">Código recarga</th>
                                <th class="">Data do recarga</th>
                                <!--<th class="">Incentivo</th>-->
                                <th class="">Valor</th>
                                <th class="">Data de liberação</th>
                                <th>Status</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor=" let item of purchases  | paginate: { itemsPerPage: showItem, currentPage: currentPage }" class=" list-table-cell">
                                <td class="clickable">{{item.purchaseId}}</td>
                                <td class="clickable">{{item.purchaseDate | date: 'dd/MM/yyyy'}}</td>
                                <!--<td class="clickable">{{item.purchaseDescription}}</td>-->
                                <td class="clickable">{{item.purchaseValue | currency:'BRL':true}}</td>
                                <td class="clickable">{{item.releaseDate | date: 'dd/MM/yyyy'}}</td>
                                <td class="clickable">
                                    <span *ngIf="item.purchaseState === 5">
                                        <img class="img-status" src="./assets/icons/status-green.png" />
                                    </span>
                                    <span *ngIf="item.purchaseState !== 5">
                                        <img class="img-status" src="./assets/icons/status-yellow.png" />
                                    </span>
                                    {{item.purchaseStateDescription}}
                                    <!-- {{item.descricaoSituacao}}
                                    <span *ngIf="item.situacaoId === SituacaoCompra.ProcessadoComSucesso">
                                        por {{item.gestorNomeAlteracao}}
                                    </span> -->
                                </td>

                                <td>
                                    <div ngbDropdown class="d-inline-block menu-option">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                            <img src="assets/icons/menu.png" />
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">
                                                <div ngbDropdownItem (click)="details(item)">
                                                    <img src="assets/icons/pencil-purple.png" class="mr-2" /> Detalhes
                                                    da recarga
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="page-custom">
                        <pagination-controls (pageChange)="changePage($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                    <div *ngIf="purchases.length == 0" class="text-center">
                        <h6>
                            Nenhum recarga encontrado
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>


<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="container custom-filter">
        <div class="row mx-5">
            <div class="col-12 custom-filter-title my-5">Aplicar filtro</div>

            <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <input id="fDataProcessamento" #fDataProcessamento class="custom-filter-input" type="date"
                        value="{{filtroDataProcessamento}}">
                    <label class="custom-filter-label" for="fDataProcessamento">Data de Processamento:</label>
                </div>
            </div>

            <div class="col-12 text-center my-5">
                <button class="custom-filter-button" type="button"
                    (click)="applyFilter(fDataProcessamento.value);modal.dismiss('Close click')">
                    APLICAR
                </button>
            </div>
        </div>
    </div>
</ng-template>
